import { render, staticRenderFns } from "./ContentFavorites.vue?vue&type=template&id=21bdde40&scoped=true&"
import script from "./ContentFavorites.vue?vue&type=script&lang=js&"
export * from "./ContentFavorites.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ContentFavorites.vue?vue&type=style&index=0&id=21bdde40&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21bdde40",
  null
  ,true
)

export default component.exports